'use client';

import { type FC, useEffect, useState } from 'react';

import UltraCartService from '@hyex/modules/portal/ultracart/uc.cart.service';
import { DigitalProduct } from '@hyex/dxp/types/store/Product/DigitalProduct';
import Image from 'next/image';
import AddCartButton from '@hyex/modules/shared/base/AddCartButton';
import ProductPrice from '@hyex/modules/shared/Product/common/ProductPrice';
import ProductDescription from '@hyex/modules/shared/Product/common/ProductDescription';
import useIsMobile from '@hyex/utils/hooks/useIsMobile';

type PropTypes = {
  product: Omit<DigitalProduct, 'asset'> & { skuId: string };

  addCartDisabled: boolean;
};

//TODO: SSR in future! Not easy.. (disabledSkus)
const DigitalProductOrderController: FC<PropTypes> = ({ product, addCartDisabled }) => {
  const isMobile = useIsMobile(1000);

  const [disabledSkus, setDisabledSkus] = useState<Record<string, boolean>>({});

  const disabledButton = addCartDisabled || disabledSkus[product.sku] === true;

  useEffect(() => {
    const handleCartChange = (beforeStateNull: boolean) => {
      const newDisabledSkus: Record<string, boolean> = {};

      const items = UltraCartService.getItems();

      items && items.forEach((item) => (newDisabledSkus[item.item_id] = true));

      setDisabledSkus(newDisabledSkus);
    };

    UltraCartService.subscribe(handleCartChange);

    UltraCartService.forceNotify();

    return () => UltraCartService.unsubscribe(handleCartChange);
  }, []);

  const onAddToCart = () => {
    const newItemToCart = product;

    UltraCartService.addToCart(
      newItemToCart,
      () => {
        setDisabledSkus((prevDisabledSkus) => ({
          ...prevDisabledSkus,
          [newItemToCart.sku]: true,
        }));
      },
      (error) => console.error(error)
    );
  };

  //TODO: Make productPrice oriented per display, for each custom price we need to have own component

  return (
    <section className={`product-main-details digital-version ${isMobile ? 'sm' : ''}`}>
      <div className="container">
        <div className="product-image" data-testid="product-images" style={{ left: '10%' }}>
          <Image src={product?.images?.single ?? ''} alt="" width={300} height={500} />
        </div>

        <div className="product-functions">
          <div className="main-product-block">
            <div className="product-info-block">
              <h1 className="product-name">{product.title}</h1>

              <ProductPrice
                price={product.price} //oldPrice or price
                onSale={product?.isOnSale ?? false}
                salePrice={product.bestPrice}
                withSaleBadge={false}
              />
              <ProductDescription
                description={product.description}
                shortDescription={product?.shortDescription ?? ''}
                shortInPriority={false}
                symbolsForDescription={99999}
                className="xl digital-description "
              />
            </div>
            <div className="product-actions">
              <AddCartButton
                text={
                  addCartDisabled
                    ? 'Already In Cart'
                    : product?.isOutOfStock === true
                    ? 'Sold Out'
                    : 'Add To Cart'
                }
                className="cart-btn colored"
                onClick={onAddToCart}
                disabled={disabledButton}
              />
            </div>

            <div className="sku">SKU: {product.sku}</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DigitalProductOrderController;
